import React from "react";
import { Navigate, useLocation } from "react-router-dom";

type Props = {
  allowed: boolean;
  redirectTo?: string;
  children: React.ReactElement;
};

export default function RequirePermission({ allowed, redirectTo = "/cc/overview", children }: Props) {
  const location = useLocation();

  if (!allowed) {
    // send them away instantly; no page render
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }

  return children;
}
